import { render } from "./dlt-wind.vue?vue&type=template&id=00cc21a8&scoped=true"
import script from "./dlt-wind.vue?vue&type=script&lang=js"
export * from "./dlt-wind.vue?vue&type=script&lang=js"

import "./dlt-wind.vue?vue&type=style&index=0&id=00cc21a8&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cc21a8"]])

export default __exports__